<div class="download-progress-wrapper">
  <div class="progress-bar">
    <div class="progress-bar-fill" [style.width.%]="downloadProgress"></div>
  </div>
  <span class="progress-text">{{ downloadProgress }}%</span>
</div>

